/* eslint-disable @typescript-eslint/no-explicit-any */
import fetchClient from '@/services/apis/common';
import { postMethod, getMethod } from '@/services/apis/http-server';
export const signUp = async (body: any) => {
  try {
    const response = await fetchClient.postMethod(`client/auth/signup`, body);
    return response;
  } catch (error) {
    console.error('Error posting data: ', error);
    return error;
  }
};

export const signIn = async (body: any) => {
  try {
    const response = await fetchClient.postMethod(`client/auth/signin`, body);
    return response;
  } catch (error) {
    console.error('Error posting data: ', error);
    return error;
  }
};

export const forgotPassword = async (body: any) => {
  try {
    const response = await postMethod(`client/auth/forgot-password`, body);
    return response;
  } catch (error) {
    console.error('Error posting data: ', error);
    return error;
  }
};

export const signOut = async () => {
  try {
    const response = await postMethod(`client/auth/signout`);
    return response;
  } catch (error) {
    console.error('Error posting data: ', error);
  }
};

export const confirmPassword = async (id: string) => {
  try {
    const response = await getMethod(`client/auth/confirm-password/${id}`);
    return response;
  } catch (error) {
    console.error('Error posting data: ', error);
  }
};

export const getProfile = async () => {
  try {
    const response = await getMethod(`client/auth/profile`);
    return response;
  } catch (error) {
    console.error('Error posting data: ', error);
  }
};

export const changeProfile = async (body: any) => {
  try {
    const response = await postMethod(`client/auth/update-profile`, body);
    return response;
  } catch (error) {
    console.error('Error posting data: ', error);
  }
};

export const changePassword = async (body: any) => {
  try {
    const response = await postMethod(`client/auth/change-password`, body);
    return response;
  } catch (error) {
    console.error('Error posting data: ', error);
  }
};

export const getUserActivityList = async (body: any) => {
  try {
    const response = await getMethod('client/activity/list', body);
    return response;
  } catch (error) {
    console.error('Error fetching activity: ', error);
  }
};

export const settingUser = async (body: any) => {
  try {
    const response = await postMethod(
      'client/activity/register-notifycation',
      body,
    );

    return response;
  } catch (error) {
    console.error('Error posting data: ', error);
  }
};

export const updateFirstLogin = async () => {
  try {
    const response = await getMethod(`client/frist-login`);
    return response;
  } catch (error) {
    console.error('Error posting data: ', error);
  }
};
